export default function description() {
    return (
        <div className="card__description-basic">
            <div className="card__description">
                <div className="card__description-title">Загальна характеристика</div>
                <p className="card__description-text">
                    ГОЛІАТ — це гібрид, орієнтований на стабільний результат у складних умовах. Його основна ідея — витривалість і впевненість у врожаї, навіть при дефіциті вологи та середньому агрофоні.
                </p>
                <p className="card__description-text">
                    Гібрид демонструє хорошу пластичність і стабільність у різних регіонах вирощування.
                </p>
                <ol className="card__description-list">
                    <p className="card__description-title">
                        Продуктивність і якість
                    </p>
                    <li className="card__description-numbering">Потенціал урожайності: до 5,5 т/га</li>
                    <li className="card__description-numbering">Олійність: до 52%</li>
                    <li className="card__description-numbering">Стійкість до вовчка: A–F</li>
                    <p className="card__description-text">
                        Формує якісний урожай навіть у посушливих умовах.
                    </p>
                </ol>
                <div className="card__description-title">Морфологія та розвиток</div>
                <ol className="card__description-list">
                    <li className="card__description-numbering">Вегетаційний період: 105–108 днів</li>
                    <li className="card__description-numbering">Висота рослин: 170–190 см</li>
                    <p className="card__description-text">
                        Гібрид формує потужні рослини з хорошою облистненістю та рівномірним розвитком.
                    </p>
                </ol>
                <div className="card__description-title">Адаптивність</div>
                <ol className="card__description-list">
                    <p className="card__description-text">
                        Рекомендований для вирощування у:
                    </p>
                    <li className="card__description-numbering">Поліссі</li>
                    <li className="card__description-numbering">Лісостепу</li>
                    <li className="card__description-numbering">Степу</li>
                    <p className="card__description-text">
                        Особливо ефективний у зонах ризикованого землеробства.
                    </p>
                </ol>
                <div className="card__description-title">Поведінка в полі</div>
                <ol className="card__description-list">
                    <li className="card__description-numbering">Енергія початкового росту — 8/10</li>
                    <li className="card__description-numbering">Посухостійкість — 9/10</li>
                    <li className="card__description-numbering">Стійкість до вилягання — 8/10</li>
                    <p className="card__description-text">
                        Гібрид добре переносить стресові умови та зберігає стабільність розвитку.
                    </p>
                </ol>
                <div className="card__description-title">Ключові переваги</div>
                <ol className="card__description-list">
                    <li className="card__description-numbering">Стабільний урожай у посушливих умовах</li>
                    <li className="card__description-numbering">Гнучкість у контролі бур’янів (Clearfield®)</li>
                    <li className="card__description-numbering">Стійкість до несправжньої борошнистої роси</li>
                    <li className="card__description-numbering">Адаптивність до різних зон вирощування</li>
                </ol>
                <div className="card__description-title">Практичне застосування</div>
                <ol className="card__description-list">
                    <p className="card__description-title">
                        ГОЛІАТ — оптимальний вибір для:
                    </p>
                    <li className="card__description-numbering">екстенсивних господарств</li>
                    <li className="card__description-numbering">регіонів із дефіцитом вологи</li>
                    <li className="card__description-numbering">полів із середнім рівнем агрофону</li>
                    <p className="card__description-text">
                        Рекомендується застосування гербіцидів системи Clearfield®.
                    </p>
                </ol>
                <div className="aside__title">Агрохімічні характеристики</div>
                <div className="aside__content">
                    <div className="aside-char--basic">
                        <div className="aside-char__head">Енергiя початкового росту</div>
                        <div className="aside-char__char">
                            <div className="aside-char__items aside-char__items--8">
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                            </div>
                            <div className="aside-char__count">8</div>
                        </div>
                    </div>
                    <div className="aside-char--basic">
                        <div className="aside-char__head">Посухостiйкiсть</div>
                        <div className="aside-char__char">
                            <div className="aside-char__items aside-char__items--9">
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                            </div>
                            <div className="aside-char__count">9</div>
                        </div>
                    </div>
                    <div className="aside-char--basic">
                        <div className="aside-char__head">Стiйкiсть до вилягання</div>
                        <div className="aside-char__char">
                            <div className="aside-char__items aside-char__items--8">
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                            </div>
                            <div className="aside-char__count">8</div>
                        </div>
                    </div>
                </div>
                <p className="card__description-text">
                    ГОЛІАТ — це гібрид для тих, хто хоче впевненість у результаті незалежно від умов. Надійне рішення для стабільного прибутку.
                </p>
            </div>
            <div className="card__description-preference">
                <div className="aside__title--new">Головні переваги</div>
                <div className="asede__head">
                    <div className="aside__block">Впевненість в отриманні врожаю в посушливих умовах за рахунок посухостійкості</div>
                    <div className="aside__block">Гнучкість у контролі бур’янів завдяки Clearfield® - технології</div>
                    <div className="aside__block">Стійкий до несправжньої борошнистої роси</div>
                </div>
            </div>
        </div>
    );
}
